export enum AuthorityDocumentType {
  REGISTER_DOCUMENT_TYPE_REPORTS = '1.12.5',
  REGISTER_DOCUMENT_TYPE_EDIT = '1.12.4',
  REGISTER_DOCUMENT_TYPE_DELETE = '1.12.3',
  REGISTER_DOCUMENT_TYPE_ADD = '1.12.2',
  REGISTER_DOCUMENT_TYPE_VIEW = '1.12.1',
  REGISTER_DOCUMENT_TYPE_REGISTRATION = '1.12',
}
